import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import moment from 'moment-timezone';

import { Message } from '@app/api';

interface Props {
  message: Message;
  showDate: boolean;
  participantView?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginTop: theme.marginBase * 2,
  },
  msgContainer: {
    marginTop: theme.marginBase / 2,
    borderRadius: theme.borderRadius.std,
    display: 'flex',
    justifyContent: ({ isAccountUser }: any) =>
      isAccountUser ? 'flex-end' : 'flex-start',
  },
  content: {
    ...theme.fonts.caption,
    padding: theme.marginBase * 2,
    maxWidth: 472,
    whiteSpace: 'pre-wrap',
    // Optionnal - If signature parsing fails, text still stays inside message box
    overflowWrap: 'break-word',

    backgroundColor: ({ isAccountUser }: any) =>
      isAccountUser ? theme.colors.greenMuted : theme.colors.grayBackground,
  },
  hour: {
    ...theme.fonts.caption,
    color: theme.colors.inkTertiary,
    marginTop: theme.marginBase,
    textAlign: ({ isAccountUser }: any) => (isAccountUser ? 'right' : 'left'),
  },
  date: {
    ...theme.fonts.label,
    color: theme.colors.inkTertiary,
    textAlign: 'center',
  },
}));

export const MessageDetail = ({
  message,
  showDate,
  participantView,
}: Props) => {
  const theme: Theme = useTheme();

  const isAccountUser = !!message.accountId;

  const view = participantView ? !isAccountUser : isAccountUser;

  const classes = useStyles({ theme, isAccountUser: view });

  return (
    <div className={classes.container}>
      {showDate && (
        <p className={classes.date}>{moment(message.sendAt).format('LL')}</p>
      )}
      <div>
        <p className={classes.hour}>{moment(message.sendAt).format('LT')}</p>
        <div className={classes.msgContainer}>
          <p className={classes.content}>{message.content}</p>
        </div>
      </div>
    </div>
  );
};
